import React, { useRef, useState } from "react";
import { Button } from 'primereact/button';
import { apiRequest } from "@/Helpers/general";
import { Messages } from 'primereact/messages';
import TextInputTemplate from "@/Components/Templates/Forms/TextInputTemplate";
import { getFormErrorMessage, isFormFieldValid, validateForm } from "@/Helpers/forms";

/**
 * Component which handles the forgot password
 */
const ForgotPasswordForm = () => {
    const initialFormData = {
        email: '',
    };
    const messages = useRef();

    const [formData, setFormData] = useState(initialFormData);
    const [formErrors, setFormErrors] = useState({});
    const [formLoading, setFormLoading] = useState(false);
    const [successfullySent, setSuccessfullySent] = useState(false);

    /**
     * Update the state of the form data (when changing an input value)
     *
     * @param {string} name the name of the input
     * @param {string} value the new value of the input
     */
    const changeFormData = (name, value) => {
        let getFormData = { ...formData };

        getFormData[name] = value;

        setFormData(getFormData);
    };

    /**
     * Submits the forgot password form
     */
    const submitForm = async () => {
        messages.current.clear();
        setFormLoading(true);

        let validation = validateForm([
            {
                field: 'email',
                rules: [{ name: 'email' }, { name: 'required' }]
            }
        ], formData, setFormErrors);

        if (validation) {
            apiRequest('post', 'reset-pass', {
                data: { email: formData.email },
                onSuccess: (response) => {
                    setFormLoading(false);

                    if (response.data) {
                        setSuccessfullySent(true);

                        messages.current.show({
                            severity: 'info',
                            detail: 'An mail with a reset password link has been sent to ' + formData.email + '.',
                            sticky: true,
                            closable: false
                        });
                    }
                },
                onFailure: (error) => {
                    setFormLoading(false);

                    if (error.status == 404) {
                        setFormErrors({ email: 'Email was not found.' });

                    } else {
                        messages.current.show({ severity: 'error', detail: 'Server error', sticky: true });
                    }
                }
            }, {
                noAuth: true
            });

        } else {
            setFormLoading(false);
        }
    };

    return (
        <div className="forgot-password-form">
            {!successfullySent &&
                <div className="grid">
                    <div className="col-12">
                        <h3>Forgot password?</h3>
                        <p className="mb-3">Please enter your email address.</p>
                    </div>

                    <div className="col-12">
                        <div className="grid">
                            <div className="col-9">
                                <TextInputTemplate name="email" label="Email" value={formData.email} floatLabel noMargins
                                    onChangeFunction={changeFormData}
                                    isValid={isFormFieldValid(formErrors, 'email')}
                                    errorMessage={getFormErrorMessage(formErrors, 'email')}
                                />
                            </div>

                            <div className="col-3">
                                <Button className="w-full block" label="Send" onClick={submitForm} loading={formLoading} loadingIcon="pi pi-spin pi-sun" iconPos="center" />
                            </div>
                        </div>
                    </div>
                </div>
            }

            <div className="grid">
                <Messages ref={messages} className="no-margins"></Messages>
            </div>
        </div>
    );
};

export default ForgotPasswordForm;
